/**
 * In this file use to contains the physician Module MemberProfile screen UI and Logic
 **/
import { Link, useParams, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import ApiService from "../../services/ApiService";
import Pagination from "../components/Pagination";
import moment from "moment";
import {
  convertDOBtoMonth,
  formatMeasurement,
  convertS3privateToPublic,
  goBack,
  convertDOBtoAge,
  convertUTCtoLocal,
  convertUTCtoDate,
  convertTimeFormat,printMeasurementAge
} from '../../services/UtilsService';
import { postAnalytics } from "../../services/ReusabilityService";
import Vacccination from "../components/Vaccination";
import Development from "../components/Development";
import VitalsModal from "../modals/VitalsModal";
import DiagnosisAddModal from "../modals/DiagnosisAddModal";
import DiagnosisViewModal from "../modals/DiagnosisViewModal";
import AddMedicalInfoModal from "../modals/AddMedicalInfoModal";
import PrescriptionViewModal from "../modals/PrescriptionViewModal";
import { useTranslation } from 'react-i18next';

function MemberProfile() {
  //Intial state declaraction
  let { id } = useParams();
  const [memberData, setMemberData] = useState([]);
  const [parentData, setParentData] = useState([]);
  const [physicianData, setPhysicianData] = useState([]);
  const [measurementData, setMeasurementData] = useState([]);
  const [request, setRequest] = useState({ page: 0, limit: 10, id: id });
  const [param, setParam] = useState({ page: 0, limit: 10, id: id });
  const [medicalData, setMedicalData] = useState([]);
  const [modal, setModal] = useState({});
  const [vaccinationData, setvaccinationData] = useState([]);
  const [developmentData, setDevelopmentData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const role = Number(localStorage.getItem('role'));
  const dayRanges = {
    'monday-friday': 'Mo, Tu, We, Th, Fr',
    'monday-wednesday': 'Mo, Tu, We',
    'thursday-friday': 'Th, Fr',
    'saturday-sunday': 'Sa, Su',
  };
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [prescriptionModal, setPrescriptionModal] = useState({ showPrescription: false, prescription_items: [], name: '', main_problem: '' }); 

  //Component Initialize function trigger when request id change
  useEffect(() => {
    (async () => {
      var response = await ApiService.getMemberProfile(id);
      if (response.status === 200) {
        setMemberData({
          ...response.data.item,
          dobs: convertDOBtoMonth(response.data?.item?.dob),
        });
        // Save the formatted `dob` in localStorage
      const formattedDOB = convertDOBtoMonth(response.data?.item?.dob);
      localStorage.setItem('memberDOB', response.data?.item?.dob);

        setParentData(response.data.parentInfo);
        sessionStorage.setItem("parent", response.data.item.parent);
        setPhysicianData(response.data.physicianInfo);
      }

      var vaccinationResponse = await ApiService.getMemberVaccination({
        id: id,
      });
      if (vaccinationResponse.status === 200) {
        setvaccinationData(vaccinationResponse.data.items);
      }

      var developmentResponse = await ApiService.getMemberDevelopment({
        id: id,
      });
      if (developmentResponse.status === 200) {
        setDevelopmentData(developmentResponse?.data?.items);
      }
      if (!sessionStorage.getItem("screenStartTime")) {
        sessionStorage.setItem("screenStartTime", new Date());
      }
    })();

    //To post the Analytics data
    return async () => {
      var reqData = {};
      reqData.parent = sessionStorage.getItem("parent");
      reqData.member = id;
      reqData.module = "profile";
      postAnalytics(reqData);
    };
  }, [id]);

  /* 	//Component Initialize function trigger when request values change
	useEffect(()=>{
		(async()=>{
			var response = await ApiService.listMemberMeasurement(request);
			if(response.status===200){
			 setMeasurementData(response.data);
			}
		})();
	},[request]);
 */

  const calculateDifference = (createdAt, dob) => {
    const startDate = moment(dob);
    const endDate = moment(createdAt);
    const diffDays = endDate.diff(startDate, 'days');
  
    if (diffDays < 7) {
      return `${diffDays} day${diffDays > 1 ? 's' : ''}`;
    } else if (diffDays < 30) {
      return `${Math.ceil(diffDays / 7)} week${Math.ceil(diffDays / 7) > 1 ? 's' : ''}`;
    } else if (diffDays < 365) {
      return `${Math.floor(diffDays / 30)} month${Math.floor(diffDays / 30) > 1 ? 's' : ''}`;
    } else {
      return `${Math.floor(diffDays / 365)} year${Math.floor(diffDays / 365) > 1 ? 's' : ''}`;
    }
  };
  
  //Component Initialize function trigger when request values change
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        var response = await ApiService.listMemberMeasurement(request);
        console.log("Measurement Response Data:", response.data);
        if (response.status === 200) {
          // Fetch member profile to get the DOB
          const profileResponse = await ApiService.getMemberProfile(request.id); // Use appropriate member ID
          if (profileResponse.status === 200) {
            const dob = profileResponse.data?.item?.dob; // Extract dob
            const count = response?.data?.count;
            console.log("c",count);
            const enrichedData = (response.data.items || []).map((item) => ({
              ...item,
              dob,
              count:Number(count),
              // difference: printMeasurementAge(item.age_range),
            }));
            
            // Store enriched data
            setMeasurementData(enrichedData);
            
          }
        }
      } catch (error) {
        console.error("Error fetching member measurement data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [request]);

  //Component Initialize function trigger when param values change
  useEffect(() => {
    (async () => {
      var response = await ApiService.listMemberMedicalIssue(param);
      if (response.status === 200) {
        setMedicalData(response.data);
      }
    })();
  }, [param]);

  /**
   * To handle pagination event for Measurement screen
   * @data we pass the page number
   **/
  const handlePaginate = (data) => {
    setRequest({ ...request, page: data });
  };

  /**
   * To handle pagination event for Medical Issues screen
   * @data we pass the page number
   **/
  const handlePaginates = (data) => {
    setParam({ ...param, page: data });
  };

  //To close modal
  const handleClose = () => setModal({});

  const handleClick = () => {
    navigate(`/hospital/admin/edit-children/${parentData.account}`, {
      state: { memberId: memberData.id }
    });
  };

  // To handle View Prescription click
	const ViewPrescription = (item) => {
		setPrescriptionModal({
			showPrescription: true,
			prescription_items: item.prescription_items || [],
			main_problem: item.main_problem,
			name: memberData?.name,
			dob: memberData?.dob
		});
	};

	// To close prescription modal
	const handlePrescriptionClose = () => {
		setPrescriptionModal({ showPrescription: false, prescription_items: [], name: '', main_problem: '' });
	};

  return (
    <>
      {/*Import VitalsModal*/}
      {Object.keys(modal).length !== 0 && modal.showVitals && (
        <VitalsModal data={modal} handleClose={handleClose} />
      )}

      {/*Import DiagnosisAddModal*/}
      {Object.keys(modal).length !== 0 && modal.addDiagnosis && (
        <DiagnosisAddModal data={modal} handleClose={handleClose} />
      )}

      {/*Import DiagnosisViewModal*/}
      {Object.keys(modal).length !== 0 && modal.viewDiagnosis && (
        <DiagnosisViewModal data={modal} handleClose={handleClose} />
      )}

      {/*AddMedicalInfoModal*/}
      {Object.keys(modal).length !== 0 && modal.addInfo && (
              <AddMedicalInfoModal data={modal} handleClose={handleClose} />
      )}

      {/* Prescription View Modal */}
      {Object.keys(prescriptionModal).length !==0 && prescriptionModal.showPrescription &&
        <PrescriptionViewModal 
          data={prescriptionModal} 
          handleClose={handlePrescriptionClose} 
        />
      }
      
      <main id="main" className="main">
        <div className="pagetitle clearfix">
          <div className="float-start">
            {role===4 ? <h1>{t('sidebar.viewChildInfo')}</h1>:<h1>{t('sidebar.memberProfile')}</h1>}
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to={role===4 ? '/hospital/admin/dashboard' : '/physician/dashboard'}>
                    {t('sidebar.home')}
                  </Link>
                </li>
                {role===4 ? <>
                  <li className="breadcrumb-item">
                  <Link to='/hospital/admin/children'>
                    {t('sidebar.children')}
                  </Link>
                </li>
                  <li className="breadcrumb-item active">
                  {t('sidebar.viewChildInfo')}
                </li>
                </> :
                <li className="breadcrumb-item active">
                  {t('sidebar.memberProfile')}
                </li>}
              </ol>
            </nav>
          </div>
          <div className="float-end mt-2 me-1">
            <span onClick={goBack} className="backIcon">
              <i className="iconly-Bold-ArrowLeftSquare"></i>
            </span>
          </div>
        </div>
        {/*Page Content Section*/}
        <section>
          <div className="row">
            {/*ProfileImg*/}
            <div className="col-lg-3">
              <div className="card profile-img">
                <div className="card-body">
                  <div className="top-bar">
                    {memberData?.photo === "default.png" ? (
                      <img
                        className="img-fluid d-block mx-auto"
                        src="/assets/img/user-avatar.png"
                        alt="UN"
                      />
                    ) : (
                      <img
                        className="img-fluid d-block mx-auto"
                        src={convertS3privateToPublic(memberData?.photo)}
                        alt="UN"
                      />
                    )}
                    <h1>{memberData.name ? memberData?.name : "--"}</h1>
                    <h6 className={`${role === 4 ? 'text-tmAquaGreen' : 'text-tmPink'}`}>
                      {memberData.gender === 0 ? t('common.boy') : t('common.girl')} -{" "}
                      {convertDOBtoAge(memberData.dob, t)}
                    </h6>
                  </div>
                  <div className="center-bar clearfix">
                    <div className="d-flex align-items-center mb-4">
                      <div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
                        <i className="fa-solid fa-weight-scale" />
                      </div>
                      <div className="ms-2">
                        <p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>
                          {t('table.weight')} /{" "}
                          {t('table.height')}
                        </p>
                        <Link className="h6 text-dark">
                          {memberData.latest_weight &&
                          memberData.latest_weight !== "0"
                            ? `${formatMeasurement(
                                memberData.latest_weight
                              )} ${t('common.kg')}`
                            : "--"}
                          <span className="mx-2">/</span>{" "}
                          {memberData?.latest_height &&
                          memberData.latest_height !== "0"
                            ? `${formatMeasurement(
                                memberData.latest_height
                              )} ${t('common.cm')}`
                            : "--"}
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-4">
                      <div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
                        <i className="fa-solid fa-droplet" />
                      </div>
                      <div className="ms-2">
                        <p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>
                          {t('table.bloodGroup')}
                        </p>
                        <Link className="h6 text-dark text-capitalize">
                          {memberData.blood_group
                            ? memberData?.blood_group
                            : "--"}
                        </Link>
                      </div>
                    </div>
                    <div className="d-flex align-items-center mb-4">
                      <div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
                        <i className="fa-solid fa-user-large" />
                      </div>
                      <div className="ms-2">
                        <p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>
                          {t('table.parentName')}{" "}
                        </p>
                        <Link className="h6 text-dark text-capitalize">
                          {parentData.first_name
                            ? parentData?.first_name +
                              " " +
                              parentData?.last_name
                            : "--"}
                        </Link>
                      </div>
                    </div>
                    {role === 4 && <>
                      <div className="d-flex align-items-center mb-4">
                      <div className={`info-icon ${role === 4 ? 'admin-info-icon' : ''}`}>
                        <i className="fa-solid fa-user-doctor" />
                      </div>
                      <div className="ms-2">
                        <p className={`mb-0 ${role === 4 ? 'text-tmAquaDgreen' : 'text-tmBlue'}`}>
                          {t('profile.physicianName')}{" "}
                        </p>
                        <Link className="h6 text-dark text-capitalize">
                          {physicianData!==undefined && physicianData.first_name
                            ? physicianData?.first_name +
                              " " +
                              physicianData?.last_name
                            : "--"}
                        </Link>
                      </div>
                    </div>
                    </>}
                  </div>
                  { role === 4 && <>
                     <button onClick={handleClick} className={`btn ${role === 4 ? 'btn-tmAquaDgreen' : 'btn-tmBlue '} w-100 mb-3`}>
                      <i className="ri-pencil-fill align-middle"></i> {t('profile.editChildInfo')}
                    </button>
                    </>}
                    <Link
                            className={`btn ${role === 4 ? 'btn-tmAquaGreen' : 'btn-tmBlue '} w-100`}
                            onClick={() =>
                              setModal({
                                addInfo: true,
                                member: memberData.id,
                                name: memberData.name
                              })
                            }
                    >
                    {t('profile.addMedInfo')}
                                </Link>
                  
                </div>
              </div>
            </div>
            {/*ProfileInfo*/}
            <div className="col-lg-9">
              <div className={`card form-card profile-info ${role === 4 ? 'admin-profile-info' : ''}`}>
                <div className="card-body pt-4">
                  <ul
                    className="nav nav-pills nav-fill mb-4"
                    id="pills-tab"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link active"
                        id="pills-01-tab"
                        data-bs-toggle="pill"
                        href="#pills-01"
                        type="button"
                        role="tab"
                        aria-controls="pills-01"
                        aria-selected="true"
                      >
                        {t('sidebar.measurement')}
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="pills-02-tab"
                        data-bs-toggle="pill"
                        href="#pills-02"
                        type="button"
                        role="tab"
                        aria-controls="pills-02"
                        aria-selected="false"
                      >
                        {t('sidebar.development')}
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="pills-03-tab"
                        data-bs-toggle="pill"
                        href="#pills-03"
                        type="button"
                        role="tab"
                        aria-controls="pills-03"
                        aria-selected="false"
                      >
                        {t('sidebar.vaccination')}
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="pills-04-tab"
                        data-bs-toggle="pill"
                        href="#pills-04"
                        type="button"
                        role="tab"
                        aria-controls="pills-04"
                        aria-selected="false"
                      >
                        {t('sidebar.medicalIssues')}
                      </a>
                    </li>
                    <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="pills-05-tab"
                        data-bs-toggle="pill"
                        href="#pills-05"
                        type="button"
                        role="tab"
                        aria-controls="pills-05"
                        aria-selected="false"
                      >
                        {t('profile.parentInfo')}
                      </a>
                    </li>
                    {role === 4 && <>
                      <li className="nav-item" role="presentation">
                      <a
                        className="nav-link"
                        id="pills-06-tab"
                        data-bs-toggle="pill"
                        href="#pills-06"
                        type="button"
                        role="tab"
                        aria-controls="pills-06"
                        aria-selected="false"
                      >
                        {t('profile.physicianInfo')}
                      </a>
                    </li>
                    </>}
                  </ul>
                  <div className="tab-content" id="pills-tabContent">
                    {/*TAB-01*/}
                    <div
                      className="tab-pane fade active show"
                      id="pills-01"
                      role="tabpanel"
                      aria-labelledby="pills-01-tab"
                    >
                      <div className={`table-responsive ${role === 4 ? 'admin-table-responsive' : ''}`}>
                        <table className="table table-borderless theme-table text-nowrap ">
                          <thead>
                            <tr>
                              <th scope="col">
                                {t('table.measurementDate')}
                              </th>
                              <th scope="col" className="text-center">
                                {t('table.age')}
                              </th>
                              <th scope="col" className="text-center">
                                {t('table.weight')}
                              </th>
                              <th scope="col" className="text-center">
                                {t('common.deviceName')}
                              </th>
                              <th scope="col" className="text-center">
                                {t('table.height')}
                              </th>
                              <th scope="col" className="text-center">
                                {t('table.head')}
                              </th>
                              {/* <th scope="col" className="text-center">
                                {t('table.temperature}
                              </th>
                              <th scope="col" className="text-center">
                                {t('table.heartRate}
                              </th>
                              <th scope="col" className="text-center">
                                {t('table.bloodGlucose}
                              </th> */}
                            </tr>
                          </thead>
                          {measurementData && measurementData?.length ? (
                            <tbody>
                              {measurementData.map((item, i) => (
                                <tr key={i}>
                                  <td>
                                    {/* {moment(item?.createdAt).format(
                                      "MMM D, YYYY"
                                    )} */}
                                    {convertUTCtoLocal(item?.createdAt)}
                                  </td>
                                  <td>{printMeasurementAge(item?.age_range)}</td>
                                  <td className="text-center">
                                    <Link className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}>
                                      {item.weight && item.weight !== "0"
                                        ? `${formatMeasurement(item.weight)} ${t('common.kg')}`
                                        : "--"}
                                    </Link>
                                  </td>
                                  <td className="text-center"> {item.device_name ? item.device_name : '--'}</td>
                                  <td className="text-center">
                                    <Link className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}>
                                      {item.height && item.height !== "0"
                                        ? `${formatMeasurement(item.height)} ${t('common.cm')}`
                                        : "--"}
                                    </Link>
                                  </td>
                                  <td className="text-center">
                                    <Link className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}>
                                      {item.head_circumference &&
                                      item.head_circumference !== "0"
                                        ? `${formatMeasurement(
                                            item.head_circumference
                                          )} ${t('common.cm')}`
                                        : "--"}
                                    </Link>
                                  </td>
                                  {/* <td className="text-center">
                                    <Link className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}>--</Link>
                                  </td>
                                  <td className="text-center">
                                    <Link className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}>--</Link>
                                  </td>
                                  <td className="text-center">
                                    <Link className={`table-link ${role === 4 ? 'admin-table-link' : ''}`}>--</Link>
                                  </td> */}
                                </tr>
                              ))}
                            </tbody>
                          ) : (
							!isLoading &&
                            <tbody>
                              <tr>
                                <td colSpan="11" className="text-center">
                                  {t('common.noRecord')}
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                      {/*Pagination*/}
                      {measurementData &&
                        measurementData.length !== 0 &&
                        measurementData?.length !== 0 && (
                          <div className="row my-3">
                            <div className="col-xxl-12 d-flex justify-content-center">
                              <Pagination
                                page={request.page}
                                handlePaginate={handlePaginate}
                                total={measurementData[0].count}
                              />
                            </div>
                          </div>
                        )}
                      {/*End Pagination*/}
                    </div>
                    {/*TAB-02*/}
                    <div
                      className="tab-pane fade"
                      id="pills-02"
                      role="tabpanel"
                      aria-labelledby="pills-02-tab"
                    >
                      <Development data={developmentData} bodyWidth={"130%"} />
                    </div>
                    {/*TAB-03*/}
                    <div
                      className="tab-pane fade"
                      id="pills-03"
                      role="tabpanel"
                      aria-labelledby="pills-03-tab"
                    >
                      <Vacccination
                        dob={memberData.dobs}
                        data={vaccinationData}
                        bodyWidth={"200%"}
                      />
                    </div>
                    {/*TAB-04*/}
                    <div
                      className="tab-pane fade"
                      id="pills-04"
                      role="tabpanel"
                      aria-labelledby="pills-04-tab"
                    >
                      <div className="table-responsive">
                        <table className="table table-borderless theme-table text-nowrap">
                          <thead>
                            <tr>
                              <th>{t('table.issueDate')}</th>
                              <th>{t('table.mainProblem')}</th>
                              <th>
                                {t('table.associatedProblem')}
                              </th>
                              <th className="text-center">
                                {t('table.vitals')}
                              </th>
                              <th className="text-center">
                                {t('modal.addDiagnosis')}
                              </th>
                              <th className="text-center">
                                {t('modal.viewDiagnosis')}
                              </th>
                              <th className="text-center">
                                {t('modal.ViewPrescription')}
                              </th>
                            </tr>
                          </thead>
                          {medicalData && medicalData?.items?.length ? (
                            <tbody>
                              {medicalData.items.map((item, i) => (
                                <tr key={i}>
                                  <td>{convertUTCtoLocal(item.createdAt)}</td>
                                  <td>{item.main_problem}</td>
                                  <td>
                                    {item.associated_problem +
                                      " - " +
                                      convertUTCtoDate(item.createdAt)}
                                    <br />
                                    {item.update_associated_problem.map(
                                      (data, index) => (
                                        <div key={index}>
                                          {data.associated_problem} -{" "}
                                          {convertUTCtoDate(data.updatedDate)}
                                        </div>
                                      )
                                    )}
                                  </td>
                                  <td className="text-center">
                                    <span
                                      onClick={() =>
                                        setModal({
                                          showVitals: true,
                                          vitalsValue: item.vitals,
                                          member: item.member,
                                          parent: item.parent,
                                        })
                                      }
                                      className={`table-link ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`}
                                    >
                                      <i
                                        className="fa-solid fa-heart-pulse"
                                        toggle="tooltip"
                                        placement="top"
                                        title="View Vitals"
                                      ></i>
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span
                                      onClick={() =>
                                        setModal({
                                          addDiagnosis: true,
                                          member: item.member,
                                          parent: item.parent,
                                          report_id: item.id,
                                          dob:memberData?.dob,
                                        })
                                      }
                                      className={`table-link ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`}
                                    >
                                      <i
                                        className="fa-solid fa-file-medical"
                                        toggle="tooltip"
                                        placement="top"
                                        title="Add Diagnosis"
                                      />
                                    </span>
                                  </td>
                                  <td className="text-center">
                                    <span
                                      onClick={() =>
                                        setModal({
                                          viewDiagnosis: true,
                                          id: item.id,
                                          name: memberData?.name,
                                        })
                                      }
                                      className={`table-link ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`}
                                    >
                                      <i
                                        className="fa-solid fa-file-lines"
                                        toggle="tooltip"
                                        placement="top"
                                        title="View Diagnosis"
                                      />
                                    </span>
                                  </td>
                                  <td className="text-center">
                                      <span onClick={() => ViewPrescription(item)} style={{ cursor: 'pointer' }}>
                                      <i className={`fa-solid fa-file-lines ${role === 4 ? 'admin-table-link text-tmAquaDgreen' : 'text-tmBlue'}`} />
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          ) : (
                            <tbody>
                              <tr>
                                <td colSpan="11" className="text-center">
                                  {t('common.noRecord')}
                                </td>
                              </tr>
                            </tbody>
                          )}
                        </table>
                      </div>
                      {/*Pagination*/}
                      {medicalData &&
                        medicalData.length !== 0 &&
                        medicalData?.items?.length !== 0 && (
                          <div className="row my-3">
                            <div className="col-xxl-12 d-flex justify-content-center">
                              <Pagination
                                page={param.page}
                                handlePaginate={handlePaginates}
                                total={medicalData.count}
                              />
                            </div>
                          </div>
                        )}
                      {/*End Pagination*/}
                    </div>
                    {/*TAB-05*/}
                    <div
                      className="tab-pane fade"
                      id="pills-05"
                      role="tabpanel"
                      aria-labelledby="pills-05-tab"
                    >
                      <div className="row">
                        <div className="col-xxl-12 px-3 mb-5">
                          <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                            <h6>{t('table.parentName')}</h6>
                            <p className="text-capitalize">
                              {parentData.first_name
                                ? parentData.first_name +
                                  " " +
                                  parentData.last_name
                                : "--"}
                            </p>
                          </div>
                          <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                            <h6>{t('profile.location')}</h6>
                            <p>
                              {parentData?.address_one && (
                                <>
                                  {t('profile.addressOne') + ': ' + parentData.address_one + ', '}
                                  <br />
                                </>
                              )}

                              {parentData?.address_two && (
                                <>
                                  {t('profile.addressTwo') + ': ' + parentData.address_two + ', '}
                                  <br />
                                </>
                              )}

                              {parentData?.city && (
                                <>
                                  {t('profile.city') + ': ' + parentData.city + ', '}
                                  <br />
                                </>
                              )}

                              {parentData?.state && (
                                <>
                                  {t('profile.state') + ': ' + parentData.state + ', '}
                                  <br />
                                </>
                              )}

                              {parentData?.zipcode && (
                                <>
                                  {t('profile.zipCode') + ': ' + parentData.zipcode + ', '}
                                  <br />
                                </>
                              )}

                              {!(
                                parentData?.address_one ||
                                parentData?.address_two ||
                                parentData?.city ||
                                parentData?.state ||
                                parentData?.zipcode
                              ) && '--'}
                            </p>
                          </div>
                          <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                            <h6>{t('profile.email')}</h6>
                            <p>{parentData.email ? parentData?.email : "--"}</p>
                          </div>
                          <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                            <h6>{t('profile.phoneNumber')}</h6>
                            <p>
                              {parentData.countryCode
                                ? parentData?.countryCode
                                : "--"}{" "}
                              {parentData.mobileNumber
                                ? parentData?.mobileNumber
                                : "--"}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    {role === 4 && <>
                    {/* <!--TAB-06--> */}
                    <div className="tab-pane fade" id="pills-06" role="tabpanel" aria-labelledby="pills-06-tab">
                      <div className="row">
                        <div className="col-xxl-12 px-3 mb-5">
                          <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                            <h6>{t('profile.physicianName')}</h6>
                            <p className="text-capitalize">
                              {physicianData!==undefined && physicianData.first_name
                                ? physicianData.first_name +
                                  " " +
                                  physicianData.last_name
                                : "--"}
                            </p>
                          </div>
                          <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                            <h6>{t('profile.roleAndDepartment')}</h6>
                            <p>{physicianData!==undefined && physicianData.specialist
                                ? physicianData.specialist
                                : "--"}</p>
                          </div>
                          {physicianData!==undefined && physicianData.workSchedules !== undefined && <>
                            <div className={`secContent ${role === 4 ? 'admin-secContent' : ''}`}>
                              <div className="d-flex">
                                {/* Visiting Days */}
                                <div className="me-5">
                                  <h6>{t('profile.visitingDays')}</h6>
                                  {physicianData!==undefined && physicianData.workSchedules.map((schedule, index) => (
                                    <p key={index} className="mb-2">
                                      {schedule.days && schedule?.days.length > 0 ? (
                                         schedule?.days
                                        .map(day =>[day.trim()] || '--') 
                                        .reduce((acc, curr, index) => (
                                        <>
                                          {acc}
                                          {index > 0 && ', '}
                                          {curr}
                                        </>
                                        ), '')) : (
                                          '--' // Change: Added fallback for no days
                                        )}
                                    </p>
                                  ))}
                                </div>
                                {/* Visiting Timings */}
                                <div className="me-1">
                                  <h6>{t('profile.visitingTiming')}</h6>
                                  {physicianData!==undefined && physicianData.workSchedules.map((schedule, index) => (
                                    <p key={index} className="mb-2">
                                      {schedule?.startTime ? convertTimeFormat(schedule?.startTime) : '--'}
																			{schedule?.startTime && schedule?.endTime && ' to '}
																			{schedule?.endTime && convertTimeFormat(schedule?.endTime)}
                                    </p>
                                  ))}
                                </div>
                              </div>
                          </div>
                          </>}
                        </div>
                      </div>
                    </div>	
                    </>}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*End Page Content Section*/}
      </main>
    </>
  );
}

export default MemberProfile;
